import script from "./CardBuy.vue?vue&type=script&lang=ts&setup=true"
export * from "./CardBuy.vue?vue&type=script&lang=ts&setup=true"

import "./CardBuy.vue?vue&type=style&index=0&id=48cb5fd5&scoped=true&lang=css"

import exportComponent from "/Users/jnshul/Documents/tagluffa_i_vue3/main_page/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48cb5fd5"]])

export default __exports__